import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import SalesQuoteList from "../../components/salesQuotes/SalesQuoteList";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function SalesQuotes() {
  const { t } = useTranslation("accounts");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: t("Sales Quotes"),
      desc: t("Baskets saved for a customer to come back to"),
    });
  }, [t]);

  return (
    <div className="bg-white shadow rounded-lg mt-4 overflow-hidden">
      <SalesQuoteList />
    </div>
  );
}
